import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WindowModule } from '@progress/kendo-angular-dialog';
import { CustomWindowService } from 'app/core/services/custom-window-service/custom-window.service';
import { HtmlContentDialogComponent } from './html-content-dialog.component';
import { I18nModule } from '../i18n/i18n.module';

@NgModule({
  imports: [CommonModule, WindowModule, I18nModule],
  declarations: [HtmlContentDialogComponent],
})
export class CustomWindowModule {
  public static forRoot(): ModuleWithProviders<CustomWindowModule> {
    return {
      ngModule: CustomWindowModule,
      providers: [CustomWindowService],
    };
  }
}
